import BaseProduct from './BaseProduct';
import { ProductId } from '../types';
import store, { getLayerOpacity } from '../state';
import { getTileUrl } from '../config';

export class SunIntensityLayer extends BaseProduct {
  public readonly id: ProductId = 'sun_intensity';

  private unsubscribeStore: (() => void) | null = null;

  protected onActivate(): void {
    this.refresh();
    let lastModel = store.getState().selectedModels['sun_intensity'] || store.getState().selectedModels['sun_intensity_forecast'] || store.getState().sunIntensityModel || 'rrfs';
    this.unsubscribeStore = store.subscribe((s) => {
      if (!this.active) return;
      const currentModel = s.selectedModels['sun_intensity'] || s.selectedModels['sun_intensity_forecast'] || s.sunIntensityModel || 'rrfs';
      if (currentModel !== lastModel) {
        lastModel = currentModel;
        this.refresh();
      }
    });
  }

  protected onDeactivate(): void {
    if (this.unsubscribeStore) {
      this.unsubscribeStore();
      this.unsubscribeStore = null;
    }
    this.layerManager.removeBufferedRasterLayer(this.id);
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    this.refresh();
  }

  public refresh(targetTimeMs?: number) {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const opacity = getLayerOpacity(this.id, 1.0);
    const current = targetTimeMs !== undefined ? targetTimeMs : state.currentTimeStep;
    if (!current) return;

    const model = state.selectedModels['sun_intensity'] || state.selectedModels['sun_intensity_forecast'] || state.sunIntensityModel || 'rrfs';

    const ok = this.updateStandardInterpolatedRaster({
      layerId: this.id,
      product: this.id,
      model,
      targetTime: current,
      opacity,
      minzoom: 0,
      maxzoom: 5
    });
    if (!ok) {
      const d = typeof current === 'number' ? new Date(current) : current;
      const dateStr = d.toISOString().split('T')[0];
      const hourStr = String(d.getUTCHours()).padStart(2, '0');
      const tiles = [getTileUrl(manifest, this.id, model, dateStr, hourStr)];
      this.layerManager.updateBufferedRasterLayer(this.id, tiles, opacity, undefined, 0, 5);
    }
  }
}
export default SunIntensityLayer;
